module.exports = __webpack_public_path__ + "img/IEC30503.86109fe3.png";